import React, {FC, useContext} from 'react';
import style from './style.module.scss';
import {AppliedFilterSingleItem} from 'plugins/modules/filter/components/AppliedFilterSingleItem';
import {FilterPickupTodayButtonContext} from 'plugins/modules/filter/context/FilterPickupTodayButtonContext';
import {useExpressOrderClear} from 'plugins/modules/filter/hooks/useExpressOrderClear';

const ExpressOrderAppliedFilter: FC = () => {
    const {wineShop} = useContext(FilterPickupTodayButtonContext);
    const {handleClearExpressOrder} = useExpressOrderClear();

    if (!wineShop) {
        return null;
    }

    return (
        <div className={style.main}>
            <AppliedFilterSingleItem title={wineShop.titleVinoteki} onClear={handleClearExpressOrder} />
        </div>
    );
};

export default ExpressOrderAppliedFilter;
